module.exports = __webpack_public_path__ + "static/media/HCLTECH.1b7cecf7.txt";